import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import NonCorporateEmailDate from "@/GeneratedFixtures/NonCorporateEmailData.json";

/**
 * Field rules for the signup form. Pure functions — the hook owns the state and
 * passes what each rule needs.
 *
 * The personal-account cases take `isPersonalAccount` rather than the AccountType
 * enum, which keeps these free of any import from the hook that calls them.
 */

export function isEmailAddressProfessional(email: string): boolean {
  // TODO: Get this list from the server so it's in one place
  return !NonCorporateEmailDate.some((domain) => email.includes(domain));
}

function isCompanyNameObviouslyWrong(companyName: string) {
  const obviouslyWrong = ["na", "none", "n/a", "not applicable"];

  return obviouslyWrong.includes(companyName.toLowerCase());
}

export function errorMessageForCompanyName(
  companyName: string,
  isPersonalAccount: boolean,
): ErrorMessageType {
  if (isPersonalAccount) {
    // If it's personal, then we will just use their name as the company name
    // Otherwise we have found they just enter something like 'Non business'
    // which is confusing
    return undefined;
  }
  if (companyName.length === 0) {
    return "Required";
  }

  if (companyName.length < 5) {
    return "Must be at least 5 characters";
  }

  if (isCompanyNameObviouslyWrong(companyName)) {
    return "Please enter the correct name";
  }

  return undefined;
}

export function isPotentiallyLogisticsCompany(companyName: string): boolean {
  const lowerCaseCompanyName = companyName.toLowerCase();

  return (
    lowerCaseCompanyName.includes("logistics") ||
    lowerCaseCompanyName.includes("freight")
  );
}

export function errorMessageForShipmentFrequency(
  shipmentFrequency: string | undefined,
  isPersonalAccount: boolean,
): ErrorMessageType {
  if (isPersonalAccount) {
    // This will always be SingleShipment - they're not asked to select it
    return undefined;
  }

  return shipmentFrequency !== undefined ? undefined : "Required";
}

export function errorMessageForPassword(password: string): ErrorMessageType {
  if (password.length === 0) {
    return `Required`;
  }

  if (password.length < 8) {
    return `Must be 8 characters (${8 - password.length} to add)`;
  }

  return undefined;
}
